import { FC, useMemo } from 'react';
import { Tabs } from 'antd';
import { ActionEntityType } from '@pmp/api';
import { useTranslation } from 'react-i18next';
import { CrudMode } from '@ohpen/enso-ui';
import { useGuard } from '@ohpen/react-authz';

import { FormSchemaProps } from '../interfaces';
import { ExclusivesTab, NotesTab, ProcurationFeesTab, FirmDetailsTab } from '.';

export const FirmsFormSchema: FC<FormSchemaProps> = ({ form, mode, selectsOptions, defaultComplianceStatus, entityId, onTabChange, errorRows, setDisableSave }) => {
  const { t } = useTranslation();
  const entityType = ActionEntityType.FIRMS;
  const { allowed: showProcurationFees } = useGuard({ flags: ['enableLegacyFirmProcurationFeeAssignments'] });

  const items = useMemo(
    () => [
      {
        key: 'registration',
        label: t('firms.labels.firmsDetails'),
        children: <FirmDetailsTab form={form} mode={mode} selectsOptions={selectsOptions} defaultComplianceStatus={defaultComplianceStatus} entityId={entityId} errorRows={errorRows} setDisableSave={setDisableSave} />,
      },
      ...(showProcurationFees
        ? [{
          key: 'procuration-fees',
          label: t('firms.labels.procurationFees'),
          children: <ProcurationFeesTab form={form} mode={mode} selectsOptions={selectsOptions} />,
        }]
        : []),
      {
        key: 'exclusives',
        label: t('firms.labels.exclusives'),
        children: <ExclusivesTab form={form} mode={mode} selectsOptions={selectsOptions} />,
      },
      ...(CrudMode.CREATE === mode
        ? []
        : [{
          key: 'notes',
          label: t('firms.labels.notes'),
          children: <NotesTab form={form} mode={mode} selectsOptions={selectsOptions} entityType={entityType} entityId={entityId} />,
        }]),

    ],
    [form, mode, selectsOptions, defaultComplianceStatus, t, entityType, entityId, errorRows, setDisableSave, showProcurationFees],
  );

  return (
    <div className="enso-ui-tabs-wrapper">
      <Tabs items={items} onChange={onTabChange} />
    </div>
  );
};
